import { SignableDocument } from "../config/levelThreeSigning";

/**
 * The Level 3 screens build the Demand Note or Certificate PDF on the
 * "Save And Preview" step and sign it on the next step, and the two steps are
 * separate components that share no state. The preview step leaves the PDF's
 * address here and the signing step picks it up. It is kept only in memory,
 * so it is gone after a page reload; the officer then presses Save And Preview
 * again.
 */

const unsignedDocuments = new Map<string, string>();

const keyOf = (document: SignableDocument, applicationId: number | string) =>
  `${document}:${applicationId}`;

/** Remembers the blob address of the PDF just generated for this application. */
export function rememberUnsignedDocument(
  document: SignableDocument,
  applicationId: number | string,
  blobUrl: string
): void {
  unsignedDocuments.set(keyOf(document, applicationId), blobUrl);
}

/** Returns the PDF generated for this application, or null when there is none. */
export async function getUnsignedDocument(
  document: SignableDocument,
  applicationId: number | string
): Promise<Blob | null> {
  const blobUrl = unsignedDocuments.get(keyOf(document, applicationId));

  if (!blobUrl) return null;

  try {
    const response = await fetch(blobUrl);
    const blob = await response.blob();

    return new Blob([blob], { type: "application/pdf" });
  } catch {
    return null;
  }
}
